import styled from 'styled-components';
import { desktop1440 } from '@nubank/nuds-web/styles/breakpoints';

import { themeSpace } from 'styles/themeUtils';

const AdvantagesListItemRoot = styled.li`
  margin-bottom: ${themeSpace(2.5)};
  display: flex;

  ${desktop1440`
    margin-bottom: ${themeSpace(3)};
  `}
`;

AdvantagesListItemRoot.displayName = 'AdvantagesListItemRoot';

export default AdvantagesListItemRoot;
